import {Model} from "@vuex-orm/core";

export default class UserUserRole extends Model {

    static entity = 'userUserRoles';

    static primaryKey = ['user_id', 'user_role_id'];

    static fields () {
        return {
            user_id: this.number(null).nullable(),
            user_role_id: this.number(null).nullable(),
        }
    }
}
